import { useCallback, useEffect, useState } from 'react';

type DesktopNotificationOptions = {
    body?: string;
    icon?: string;
    tag?: string;
};

export const useDesktopNotifications = () => {
    const [permission, setPermission] = useState<NotificationPermission>('default');

    useEffect(() => {
        if ('Notification' in window) {
            setPermission(Notification.permission);
        }
    }, []);

    const requestPermission = useCallback(async () => {
        if (!('Notification' in window)) return 'denied' as NotificationPermission;
        const result = await Notification.requestPermission();
        setPermission(result);
        return result;
    }, []);

    const showDesktopNotification = useCallback((title: string, options?: DesktopNotificationOptions) => {
        if (!('Notification' in window)) return;
        if (Notification.permission !== 'granted') return;

        const notification = new Notification(title, options);
        notification.onclick = (event: Event) => {
            event.preventDefault();
            window.focus();
            notification.close();
        };

        return notification;
    }, []);

    return { permission, requestPermission, showDesktopNotification };
};
